import { Body, Field, FieldProps } from '@hover/blueprint';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

interface CheckboxFieldProps extends FieldProps {
  ariaLabel: string;
}

const Label = styled.label`
  align-items: start;
  display: grid;
  grid-column-gap: 0.5rem;
  grid-template-areas: 'checkbox children';
`;

const Checkbox = styled.input`
  grid-area: checkbox;
  margin-top: 0.25rem;
`;

const StyledBody = styled(Body)`
  cursor: pointer;
  grid-area: children;
`;

const StyledField = styled(Field)`
  padding-top: 0;
`;

const CheckboxField = ({
  ariaLabel,
  children,
  label,
  name,
  ...props
}: CheckboxFieldProps) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { errors, register } = useFormContext<Record<string, string>>();
  const error = errors[name]?.message;

  return (
    <StyledField {...props} error={error} label={label} name={name}>
      <Label htmlFor={`${name}-inner`}>
        <Checkbox
          aria-label={ariaLabel}
          id={`${name}-inner`}
          name={name}
          ref={register}
          type="checkbox"
        />
        <StyledBody margin={0} size={400}>
          {children}
        </StyledBody>
      </Label>
    </StyledField>
  );
};

export { CheckboxField };
